import { Controller } from "react-hook-form";
import { DropdownItem } from "@components";
import { cn } from "@utils";
import EditorDropdown from "./EditorDropdown";

const options = [
  { value: true, label: "PDF Statement" },
  { value: false, label: "No attachments" },
];

export default function PdfDropdown({
  control,
  watch,
  variant = "inline",
  edited = false,
  disabled = false,
}) {
  const attachPdf = watch("attachPdfStatement");

  return (
    <EditorDropdown
      label={attachPdf ? "PDF Statement" : "No attachments"}
      variant={variant}
      edited={edited}
      disabled={disabled}
      bodyClassName="min-w-56"
    >
      <div className="px-4 py-2 text-xs font-semibold text-zinc-500 uppercase tracking-wide">
        Email attachments
      </div>
      <Controller
        name="attachPdfStatement"
        control={control}
        render={({ field: { value, onChange } }) => (
          <>
            {options.map((opt) => (
              <DropdownItem
                key={String(opt.value)}
                onClick={() => onChange(opt.value)}
              >
                <span
                  className={cn(
                    "w-full select-none font-medium",
                    opt.value === value ? "text-primary-500" : "text-zinc-900",
                  )}
                >
                  {opt.label}
                </span>
              </DropdownItem>
            ))}
          </>
        )}
      />
    </EditorDropdown>
  );
}
